var render = function render(){var _vm=this,_c=_vm._self._c;return _c('topbar',{attrs:{"titulo":_vm.$t('ACADEMICO_DIARIO_CLASSE.NOTAS'),"subtitulo":_vm.$t('ACADEMICO_DIARIO_CLASSE.NOTAS_DESCRICAO'),"breadcrumbs":_vm.breadcrumbs}})
}
var staticRenderFns = []

export { render, staticRenderFns }